module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    ref: "team",
    staticClass: "team"
  }, [_c('transition-group', {
    staticClass: "team__members-photo-container-desktop",
    attrs: {
      "name": "teamMember-fade",
      "appear": ""
    }
  }, _vm._l((_vm.teamMembers), function(teamMember, index) {
    return (index === _vm.teamMemberIndex) ? _c('img', {
      key: index,
      staticClass: "team__members-photo",
      attrs: {
        "src": teamMember.image.sizes.xxxlarge,
        "srcset": teamMember.image.sizes.medium + ' 768w, ' + teamMember.image.sizes.large + ' 1024w, ' + teamMember.image.sizes.xlarge + ' 1280w, ' + teamMember.image.sizes.xxlarge + ' 1920w,' + teamMember.image.sizes.xxxlarge + ' 3000w',
        "sizes": "(min-width: 1024px) 330vh, (min-width: 425px) 1000px, 533px",
        "alt": teamMember.image.alt === '' ? 'Photo of ' + teamMember.post_title : teamMember.image.alt
      }
    }) : _vm._e()
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "team__inner wow fadeInUp",
    attrs: {
      "data-wow-delay": "0.5s"
    }
  }, [_c('header', {
    staticClass: "team__heading-content"
  }, [_vm._t("team-heading-mobile"), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeTeamMember),
      expression: "activeTeamMember"
    }],
    staticClass: "select-dark team__members",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.activeTeamMember = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "aria-label": "select"
    },
    domProps: {
      "textContent": _vm._s(_vm.optionText)
    }
  }), _vm._v(" "), _vm._l((_vm.teamMembers), function(teamMember) {
    return _c('option', {
      key: teamMember.ID,
      domProps: {
        "textContent": _vm._s(teamMember.post_title)
      }
    })
  })], 2)], 2), _vm._v(" "), _c('transition-group', {
    staticClass: "team__members-photo-container",
    attrs: {
      "tag": "div",
      "name": "teamMember-fade",
      "appear": ""
    }
  }, _vm._l((_vm.teamMembers), function(teamMember, index) {
    return (index === _vm.teamMemberIndex) ? _c('img', {
      key: index,
      staticClass: "team__members-photo",
      attrs: {
        "src": teamMember.image.sizes.large,
        "srcset": teamMember.image.sizes.medium + ' 768w, ' + teamMember.image.sizes.large + ' 1024w, ' + teamMember.image.sizes.xlarge + ' 1280w, ' + teamMember.image.sizes.xxlarge + ' 1920w',
        "sizes": "(min-width: 1024px) 330vh, (min-width: 425px) 1000px, 533px",
        "alt": teamMember.image.alt === '' ? 'Photo of ' + teamMember.post_title : teamMember.image.alt
      }
    }) : _vm._e()
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "team__member-container_left",
    class: _vm.showItem ? 'fade-primary' : null,
    attrs: {
      "data-wow-delay": "0.5s"
    }
  }, [_vm._t("team-heading-desktop"), _vm._v(" "), _c('ul', {
    staticClass: "team__member-list"
  }, _vm._l((_vm.teamMembers), function(teamMember, index) {
    return _c('li', {
      key: index,
      staticClass: "team__member-item",
      on: {
        "click": function($event) {
          return _vm.activateTeamMember(teamMember)
        }
      }
    }, [_c('button', {
      staticClass: "team__member-item-btn",
      domProps: {
        "innerHTML": _vm._s(_vm.formatTrademark(teamMember.post_title))
      }
    })])
  }), 0)], 2), _vm._v(" "), _vm._l((_vm.filteredTeamMember), function(teamMember) {
    return _c('div', {
      key: teamMember.ID,
      staticClass: "team__member-container_right"
    }, [_c('article', {
      staticClass: "team__member-description-container",
      class: _vm.showItem ? 'fade-primary' : null,
      attrs: {
        "data-wow-delay": "0.5s"
      }
    }, [_c('h3', {
      staticClass: "team__member-name",
      domProps: {
        "innerHTML": _vm._s(_vm.formatTrademark(teamMember.post_title))
      }
    }), _vm._v(" "), _vm._t("svg"), _vm._v(" "), _c('p', {
      staticClass: "team__member-copy team__member-copy--mobile",
      domProps: {
        "textContent": _vm._s(teamMember.copy)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "team__member-nav-container"
    }, [_c('button', {
      staticClass: "team__member-previous-button",
      class: _vm.teamMemberIndex === 0 ? 'team__member-previous-button--disabled' : null,
      on: {
        "click": function($event) {
          return _vm.decrementTeamMember()
        }
      }
    }, [_vm._t("carrot-svg"), _vm._v(" "), _c('p', {
      staticClass: "team__member-nav-copy",
      domProps: {
        "textContent": _vm._s('Previous')
      }
    })], 2), _vm._v(" "), _c('button', {
      staticClass: "team__member-next-button",
      class: _vm.teamMemberIndex === _vm.teamMembers.length - 1 ? 'team__member-next-button--disabled' : null,
      on: {
        "click": function($event) {
          return _vm.incrementTeamMember()
        }
      }
    }, [_c('p', {
      staticClass: "team__member-nav-copy",
      domProps: {
        "textContent": _vm._s('Next')
      }
    }), _vm._v(" "), _vm._t("carrot-svg-rotated")], 2)]), _vm._v(" "), (_vm.windowWidth >= 1024) ? _c("base-reveal", {
      tag: "div",
      attrs: {
        "base-copy": teamMember.copy
      }
    }) : _vm._e()], 2)])
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42e8b231","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Team.vue
// module id = 303
// module chunks = 1